module.exports = __webpack_public_path__ + "static/media/leisure_bgm.2b6cb931.mp3";